export default "__VITE_ASSET__BmV27sRg__"